/**
 * Delete Device Type Form Schema
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

const MIN_NUMBER = 1000000000
const MAX_NUMBER = 9999999999

export const DeleteDeviceTypeFormSchema = z.object({
  deviceTypeNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),
  deviceTypeName: z
    .string()
    .min(1, 'Device type name is required'),
})

export type DeleteDeviceTypeFormData = z.infer<typeof DeleteDeviceTypeFormSchema>

export function transformToApiRequest(formData: DeleteDeviceTypeFormData) {
  return {
    deviceTypeNumber: formData.deviceTypeNumber,
  }
}
